<template>
    <div class="ah-page reimbursement-invoice">
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>核銷轉開發票</h1>
                        <el-select v-model="yearSelect" class="title-dropdown">
                            <el-option v-for="item in yearList" :key="item.key" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                    </div>
                    <div class="actions">
                        <el-input
                            v-model="queryParams.Keyword"
                            class="search"
                            placeholder="發票號碼、買受人、買受人統編"
                            prefix-icon="el-icon-search"
                            :clearable="true"
                            style="margin-right: 10px"
                            @keyup.enter.native="onSimpleSearchKeyUp"
                            @clear="updateData(true)"
                        ></el-input>
                        <el-button v-if="!isQR()" type="highlight" @click="onAddBtnClick">新增核銷轉開發票</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row main-color">
            <div class="ah-container">
                <el-row :gutter="20">
                    <el-col :sm="6">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">
                                    核銷單累計總額
                                </div>
                                <div class="statis-num">
                                    <Money :v="amounts.totalAmount" round />
                                    <span class="cny">TWD</span>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="12">
                        <div class="ah-card main-color summary-data">
                            <div class="content">
                                <div class="statis-title">
                                    轉開發票累計總金額
                                </div>
                                <div class="statis-num">
                                    <Money :v="amounts.totalUntaxAmount" round />
                                    <span class="cny">TWD</span>
                                </div>
                            </div>
                            <div class="content">
                                <div class="statis-title">
                                    轉開發票累計稅額
                                </div>
                                <div class="statis-num">
                                    <Money :v="amounts.totalTax" round />
                                    <span class="cny">TWD</span>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="6">
                        <div class="ah-card main-color summary-data">
                            <div class="content">
                                <div class="statis-title">
                                    銷貨折讓及退回 (含稅)
                                </div>
                                <div class="statis-num">
                                    <Money :v="amounts.totalDiscountAmount" round />
                                    <span class="cny">TWD</span>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel" style="margin-top: 25px">
                <div class="panel-body">
                    <TableView :datas="datas" @detailClose="onDetailDialogClose" @sort-change="onSortChange" :loading="isLoading" ref="dataTable" />
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size.sync="queryParams.PageSize"
                        :total.sync="totalDataCount"
                        :current-page.sync="queryParams.PageNum"
                        :small="isMobile()"
                        @current-change="onPaginationChange"
                        class="pagination"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import { invoiceDatePeriod, invoiceType } from '@/assets/commonData/options';
import TableView from './TableView.vue';

export default {
    name: 'ReimbursementInvoicePage',
    components: { TableView },
    data() {
        return {
            isShowFilter: false,
            invoiceDatePeriod,
            invoiceType,
            isLoading: false,
            queryParams: {
                Keyword: null,
                PageNum: 1,
                PageSize: 25,
                StartDate: null,
                EndDate: null,
                BankStartDate: null,
                BankEndDate: null,
                VendorId: null,
                ProjectId: null,
                Status: null,
                FOO_DIS_CNL: null,
                types: null,
                AMT_Min: null,
                AMT_Max: null,
                Creators: [],
                bankSnos: [],
                itemSnos: [],
                cnyList: [],
                queryDate: null,
                queryReceiveDate: null,
                EInvoice: null,
            },
            prevQuery: {},

            OrderParam: {
                SortColumn: null,
                OrderBy: null,
            },

            datas: [],
            amounts: {
                fullTotal: null,
                progrsingTotal: null,
                toBeCreateTotal: null,
                rejectTotal: null,
                toBeCreditedTotal: null,
                creditedTotal: null,
                voidTotal: null,
            },

            totalDataCount: 0,

            yearList: [],
            isShowCnys: false,
        };
    },
    computed: {
        totalReimbursementAmount() {
            return 0;
        },
        yearSelect: {
            set(val) {
                if (!val) {
                    this.queryParams.queryDate = null;
                    this.updateData(true);
                    return;
                }

                const sd = Number(
                    moment()
                        .year(val)
                        .startOf('year')
                        .format('x'),
                );
                const ed = Number(
                    moment()
                        .year(val)
                        .endOf('year')
                        .format('x'),
                );

                this.queryParams.queryDate = [sd, ed];
                this.updateData(true);
            },
            get() {
                if (!this.queryParams.queryDate) return '所有年份';
                const year = moment(Number(this.queryParams.queryDate[0])).year();
                const daysOfYear = year % 4 === 0 ? 366 : 365;
                const sd = moment(Number(this.queryParams.queryDate[0]));
                const ed = moment(Number(this.queryParams.queryDate[1]));

                // eslint-disable-next-line eqeqeq
                if (sd.format('DDD') == 1 && ed.format('DDD') == daysOfYear) {
                    return year;
                }
                return '自訂';
            },
        },
    },
    mounted() {
        this.initYearSelect();
        this.updateData();
    },
    methods: {
        initYearSelect() {
            const START = 2020;
            const END = moment().year();

            this.yearList = [];
            // this.yearList.push({ label: '所有年份', value: null });
            for (let i = END; i >= START; i -= 1) {
                this.yearList.push({ label: i, value: i, key: `year-list-${i}-${+new Date()}` });
            }

            const sd = Number(
                moment()
                    .startOf('year')
                    .format('x'),
            );
            const ed = Number(
                moment()
                    .endOf('year')
                    .format('x'),
            );
            this.queryParams.queryDate = [sd, ed];
        },
        onSimpleSearchKeyUp() {
            this.updateData(true);
        },
        onAddBtnClick() {
            this.$router.push({ name: 'reimbursement-invoice-add' });
        },

        onPaginationChange() {
            this.updateData();
        },

        onDetailDialogClose(refresh) {
            if (refresh) this.updateData();
        },
        onSortChange(event) {
            if (event.order === 'ascending') {
                this.OrderParam.OrderBy = 1;
            }
            if (event.order === 'descending') {
                this.OrderParam.OrderBy = 2;
            }
            if (event.order === null) {
                this.OrderParam.OrderBy = null;
            }
            this.OrderParam.SortColumn = event.prop;
            this.updateData();
        },

        updateData(resetPageNum = false) {
            this.isLoading = true;

            if (resetPageNum) this.queryParams.PageNum = 1;

            this.prevQuery = { ...this.queryParams };

            let params = { ...this.queryParams, year: this.yearSelect };
            if (this.OrderParam.SortColumn !== null && this.OrderParam.OrderBy !== null) {
                params = { ...this.OrderParam, ...this.queryParams, year: this.yearSelect };
            }

            this.$api({
                url: 'TranInvoice/QueryTranInvoice',
                params: { ...params, queryDate: undefined },
                method: 'GET',
            })
                .then((resp) => {
                    console.log('TranInvoice', resp.data);
                    if (this.queryParams.PageNum !== 1 && !resp.data.totalNum) {
                        this.queryParams.PageNum -= 1;
                        this.updateData();
                        return;
                    }
                    this.datas = resp.data.items;
                    this.totalDataCount = resp.data.totalNum;
                    this.amounts = resp.data.amoutTotal;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        // getCnyRat(cny) {
        //     const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
        //     if (cnyOption) return cnyOption.rat;
        //     return 1;
        // },
        onShowCnysClick() {
            this.isShowCnys = !this.isShowCnys;
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.reimbursement-invoice {
    .amt-refund {
        color: red;

        .label {
            display: inline-block;
            border: 1px solid red;
            border-radius: 5px;
            padding: 0px 10px;
            margin-right: 10px;
        }
    }

    .search {
        width: 260px;

        @media (max-width: 720px) {
            width: 150px;
        }
    }
    .summary-data {
        display: flex;
        > div {
            flex: 1;
        }
    }
}
</style>
